import { MCP_ENVELOPE_PAIR, MCP_ENVELOPE_KEYS } from "./mcp-prefix-constants";
import { toolInput } from "../../tool-input";

/** Reads `server` and `reason` from the top level of a serialized MCP result, without parsing the whole payload. */
export function parseToolOutput(
  output: unknown,
): Record<string, unknown> | null {
  if (toolInput.isRecord(output)) return output;
  if (typeof output !== "string") return null;
  const envelope: Record<string, unknown> = {};
  if (!output.startsWith("{")) return envelope;

  MCP_ENVELOPE_PAIR.lastIndex = 1;
  let pair = MCP_ENVELOPE_PAIR.exec(output);
  while (pair) {
    const [, key, jsonValue] = pair;
    const isWantedKey = key !== undefined && MCP_ENVELOPE_KEYS.includes(key);
    if (isWantedKey && jsonValue !== undefined && !(key in envelope)) {
      envelope[key] = JSON.parse(jsonValue);
    }
    pair = MCP_ENVELOPE_PAIR.exec(output);
  }
  return envelope;
}
